<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AputPS/tc-custom/9781642791303.jpg?1726871266217" alt="This image is the cover for the book Life Worth Living"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life Worth Living
      </h1>
      <p class="bookDescription body article font2">
        <b>A moving memoir</b><b> from a man who loves Jesus, inviting others into the greatest life possible.</b><br/>  <br/> Chuck Reinhold, a beloved minister and longtime Young Life staff member, offers a grand view of his life and the principles he’s learned through his fifty-plus years of ministry. This is an inspiring memoir from a man who started ministries that have helped countless men and women meet Christ and grow in their faith—from ministry leaders like Joni Eareckson Tada to missionaries in Ethiopia to pastors, youth leaders, doctors, teachers, moms, and dads. His influence on the Kingdom in the lives of adults and leaders cannot be overstated.<br/>  <br/> Starting in the early 2000s, Chuck has faced memory obstacles. <i>A Life Worth Living</i> speaks to the power that scripture memory and time spent in God’s Word can bring to those obstacles. Chuck’s stories speak to the real struggles of those dealing with memory loss. Also, <i>A Life Worth Living</i> features principles anyone can use to further their Kingdom impact and demonstrate the impact one person’s faithfulness can have on so many.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chuck Reinhold, Joni Eareckson Tada
      </h2>
      
      <p class="authorDescription body article"><B>Chuck Reinhold</B> is an ordained Presbyterian Minister who spent his life serving on Young Life Staff and at National Presbyterian Church. After college, he went to the lowlands of Ethiopia as a missionary before going on to serve on Young Life staff in many capacities, including going to Addis Ababa Ethiopia to start Young Life. He left Ethiopia after ten years when he learned his oldest son had cancer and has remained in the states ever since. Chuck lives in Franklin, Tennessee with his daughter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?85183070